import { render, staticRenderFns } from "./GroupCreationRequests.html?vue&type=template&id=f3f21c04&scoped=true&external"
import script from "./GroupCreationRequests.vue?vue&type=script&lang=js"
export * from "./GroupCreationRequests.vue?vue&type=script&lang=js"
import style0 from "./GroupCreationRequests.scss?vue&type=style&index=0&id=f3f21c04&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3f21c04",
  null
  
)

export default component.exports